import { useMutation, useQueryClient } from "@tanstack/react-query";

import http from "../../../http";
import { CREATE_PAYMENT_ACCOUNT, GET_PAYMENT_ACCOUNTS } from "../../URL";

interface ICreatePaymentAccount {
  accountName: string;
  paymentAccountTypeCode: string;
  paymentAccountTypeCodeId?: string;
}

interface IAccountResponse {
  secretTokenKey: string;
  uniqueId: string;
}

interface IAxisErrorResponse {}

const createPaymentAccount = async (fields: ICreatePaymentAccount) => {
  const response = await http.post<IAccountResponse>(CREATE_PAYMENT_ACCOUNT, {
    ...fields,
  });

  return response.data;
};

const useCreatePaymentAccount = () => {
  const queryClient = useQueryClient();  // PR 7831723 

  return useMutation<IAccountResponse, IAxisErrorResponse, ICreatePaymentAccount>({
    mutationKey: ["create-payment-account"],
    mutationFn: createPaymentAccount,
    // PR 7831723 Start
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-accounts"] });
      queryClient.invalidateQueries({
        queryKey: ["grid", GET_PAYMENT_ACCOUNTS],
      });
    },
    // PR 7831723 End
  });
};

export default useCreatePaymentAccount;
